import { TopolTemplate } from "@/schemas/templateSchema";
import { templateSettings as defaultTemplateSettings } from "./templateSetting";
import { TopolSettingsSchema } from "@/schemas/template/settingsSchema";
import { templateStyle as defaultTemplateStyle } from "./templateStyle";
import { topolStyleSchema } from "@/schemas/template/styleSchema";

export const defaultTemplate = (
  templateSettings = defaultTemplateSettings,
  templateStyle = defaultTemplateStyle
): TopolTemplate => {
  let validSettings = defaultTemplateSettings;
  const { data, success } = TopolSettingsSchema.safeParse(templateSettings);
  if (success) {
    validSettings = data;
  }
  let validStyle = defaultTemplateStyle;
  const styleParseResult = topolStyleSchema.safeParse(templateStyle);
  if (styleParseResult.success) {
    validStyle = styleParseResult.data;
  }
  return {
    tagName: "mj-global-style",
    attributes: validSettings,
    children: [
      {
        tagName: "mj-body",
        attributes: {
          "background-color":
            validSettings.templateBackgroundColor || "#FFFFFF",
          containerWidth: validSettings.containerWidth || 600,
        },
        children: [
          {
            tagName: "mj-section",
            attributes: {
              "full-width":
                validSettings["mj-section"]?.["full-width"] || false,
              padding: validSettings["mj-section"]?.padding || "10px 0px",
              "mj-class": "section",
              "in-group": validSettings["mj-section"]?.["in-group"],
            },
            children: [
              {
                tagName: "mj-column",
                attributes: { width: "100%", "vertical-align": "top" },
                children: [],
                uid: "HJQ8ytZzW",
              },
            ],
            layout: 1,
            backgroundColor: null,
            backgroundImage: null,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            uid: "Byggju-zb",
          },
        ],
      },
    ],
    style: validStyle,
    fonts: ["Helvetica, Arial, sans-serif"],
    feedBlocksApplyToAll: {},
  };
};
